//site users
export type UserRoles =
  | "Admin"
  | "Manager"
  | "Cashier"
  | "Supervisor"
  | "Accountant"
  | "Acountant"
  | "Sales Person"
  | "System Admin"
  | "admin"
  | "manager"
  | "cashier"
  | "supervisor"
  | "acountant"
  | "sales person"
  | "none";

export enum UserRolesEnum {
  Admin = "Admin",
  Manager = "Manager",
  Cashier = "Cashier",
  Supervisor = "Supervisor",
  Accountant = "Accountant",
  Acountant = "Acountant",
  SalesPerson = "Sales Person",
  SystemAdmin = "System Admin",
  admin = "admin",
  manager = "manager",
  cashier = "cashier",
  supervisor = "supervisor",
  acountant = "acountant",
  salesperson = "sales person",
  none = "none",
}
export interface UserType {
  userId: any;
  username: string;
  userRole: UserRoles;
  tenantId: string | null;
  storeId: string | null;
}
